/**
 * Return a price as a string with currency for display purposes
 * @param price Price to display
 * @param currency THe currency to use
 */
export const displayPrice = (price: number, currency: "GBP" | "USD"): string =>
  Intl.NumberFormat("en", { style: "currency", currency }).format(price);
